import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomeNavbar() {
  const navigate = useNavigate();
  const logoSrc = 'https://static.readdy.ai/image/7e0624576d141773c913eba1868f652c/ea02af35c9a274d0014fddb0274b3cab.png';
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const items = [
    { label: 'Accueil', id: 'hero' },
    { label: 'Notre Plateforme', id: 'about' },
    { label: 'Vendeurs', id: 'vendors' },
    { label: 'Organisateurs', id: 'organizers' },
    { label: 'Services', id: 'pricing' },
  ];

  return (
    <nav className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <div className="flex items-center gap-3">
          <img src={logoSrc} alt="Foi Senegal" className="h-10 w-10 rounded-xl bg-white object-contain" />
          <span className={`text-lg font-bold tracking-tight ${scrolled ? 'text-navy' : 'text-white'}`}>Foi Senegal</span>
        </div>

        <div className="hidden items-center gap-8 md:flex">
          {items.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`cursor-pointer whitespace-nowrap text-sm font-medium transition-colors ${scrolled ? 'text-gray-600 hover:text-navy' : 'text-white/80 hover:text-white'}`}
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <button
            onClick={() => navigate('/login')}
            className={`cursor-pointer whitespace-nowrap rounded-lg border-2 px-4 py-2 text-sm font-semibold transition-all ${scrolled ? 'border-navy text-navy hover:bg-navy hover:text-white' : 'border-white text-white hover:bg-white/10'}`}
          >
            Connexion
          </button>
          <button
            onClick={() => navigate('/register')}
            className="cursor-pointer whitespace-nowrap rounded-lg bg-gold px-4 py-2 text-sm font-semibold text-white transition-all hover:bg-gold-dark"
          >
            S'inscrire
          </button>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`flex h-9 w-9 items-center justify-center cursor-pointer md:hidden ${scrolled ? 'text-navy' : 'text-white'}`}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="space-y-3 border-t border-gray-100 bg-white px-6 py-4 md:hidden">
          {items.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="block w-full cursor-pointer py-2 text-left text-sm font-medium text-gray-700 hover:text-navy"
            >
              {item.label}
            </button>
          ))}
          <div className="flex flex-col gap-2 pt-2">
            <button
              onClick={() => navigate('/login')}
              className="w-full cursor-pointer whitespace-nowrap rounded-lg border-2 border-navy py-2.5 text-sm font-semibold text-navy"
            >
              Connexion
            </button>
            <button
              onClick={() => navigate('/register')}
              className="w-full cursor-pointer whitespace-nowrap rounded-lg bg-gold py-2.5 text-sm font-semibold text-white"
            >
              S'inscrire
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
